import React from "react"
// import Leaflet from "leaflet"

import "../../Main/Main.scss"

import TopBanner from "../../../components/TopBanner/TopBanner"
import PriceCalculator from "../../../components/PriceCalculator/PriceCalculator"
import LandingFeatures from "../../../components/LandingFeatures/LandingFeatures"
import LandingHelp from "../../../components/LandingHelp/LandingHelp"
import LandingContent from "../../../components/LandingContent/LandingContent"

class CityRossosh extends React.Component {
    state = {
        map: null
    }

    componentDidMount() {
        this.moveToHash()

        // const map = Leaflet.map('map', { center: [50.19811244927663, 39.57634098623144], zoom: 8 })
        // map.whenReady(() => setTimeout(() => map.invalidateSize(), 1))
        //
        // Leaflet.tileLayer('https://geo.ati.su/osm_tiles/{z}/{x}/{y}.png', {
        //     maxZoom: 18,
        //     minZoom: 3,
        //     attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
        // }).addTo(map)
        //
        // this.setState({ map })
    }

    moveToHash() {
        const hash = window.location.hash
        if ( hash ) {
            const element = document.querySelector(hash)
            if ( element ) {
                element.scrollIntoView({ behavior: "smooth" })
            }
        }
    }

    render() {
        return (
            <section className="Main City-Rossosh">
                <TopBanner city={"Россошь"} />
                <PriceCalculator />
                <LandingContent />
                {/*<div className="map-wrapper">*/}
                {/*    <div id="map" />*/}
                {/*</div>*/}
                <LandingFeatures />
                <LandingHelp />
            </section>
        )
    }
}

export default CityRossosh
